export enum VendorLoyaltyProvider {
    Hotelchamp = "hotelchamp",
    BookingWhizz = "booking-whizz",
}
